<template>
  <div class="search-bar-page">
    <van-overlay :show="searchVisibe" :duration="0">
      <SearchControl ref="conSearch" v-model="keyword" :visibe.sync="searchVisibe" :needSaftArea="needSaftArea" @search="onSearched"
        @scan="onScan">
      </SearchControl>
    </van-overlay>
    <div class="search-bar" v-if="!searchVisibe">
      <div class="search-left" v-if="backButtonVisbile||scanButtonVisbile">
        <!-- <img v-if="backButtonVisbile" style="width:0.24rem" src="../assets/search/back.png" @click="onBack" />
        <img v-if="scanButtonVisbile" style="width:0.48rem" src="../assets/search/scan.png" @click="onScan" /> -->
      </div>
      <div class="search-centent">
        <!-- <div class="search-text" @click="onSearch"> <img src="../assets/search/search.png" /> <span>{{keyword||tipData.keyword}}</span> -->
      </div>
    </div>
    <div v-if="showSearch" class="search-text" @click="onSearch">{{searchTextValue}}</div>
  </div>
  </div>
</template>

<script>
  import SearchControl from "./SearchControl";
  import { LinkTypeCode } from "../dictionary/base.js";
  // require("../assets/fnscanner/api");
  export default {
    name: "Searchbar",
    components: { SearchControl },
    props: {
      value: {
        type: String,
        default: ""
      },
      showScanButton: {
        type: Boolean,
        default: false
      },
      showBackButton: {
        type: Boolean,
        default: false
      },
      showSearch: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: "搜索"
      },
      needSaftArea: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      value(newVal) {
        console.log(newVal);

        this.keyword = newVal;
      },
      showScanButton(newVal) {
        this.scanButtonVisbile = newVal;
      },
      showBackButton(newVal) {
        this.backButtonVisbile = newVal;
      },
      showSearch(newVal) {
        this.searchTextVisbile = newVal;
      },
      text(newVal) {
        this.searchTextValue = newVal;
      }
    },
    data() {
      return {
        searchValue: "",
        scanButtonVisbile: false,
        backButtonVisbile: false,
        searchTextVisbile: false,
        searchVisbile: false,
        keyword: "",
        searchVisibe: false,
        searchTextValue: "搜索",
        tipData: {
          keyword: "商品名称/功效"
        },
        scanInterval: 0
      };
    },
    mounted() {
      this.keyword = this.value;
      this.scanButtonVisbile = this.showScanButton;
      this.backButtonVisbile = this.showBackButton;
      this.searchTextVisbile = this.showSearch;
      this.searchTextValue = this.text;
    },
    methods: {
      onSearch() {
        //this.searchVisibe = true;
        this._go("SearchPage", {}, null, false, true);
      },
      onBack() {
        this._back();
      },
      onScan() {
        const _this = this;
        try {
          window.api.setGlobalData({ key: 'scanValue', value: '' });
          _this._requestPower('camera', function () {
            window.api.openWin({
              useWKWebView: true,
              name: "fnscanner_frm",
              url: "./fnscanner_frm.html",
              slidBackEnabled: false
            });
          })
          _this.scanInterval = setInterval(async () => {
            var windows = api.windows();
            let win = windows.find(w => {
              return w.name == "fnscanner_frm";
            });
            if (!win) {
              clearInterval(_this.scanInterval);
              var scanValue = window.api.getGlobalData({ key: 'scanValue' });
              if (scanValue !== false) {
                if (scanValue.length > 2 && scanValue.substring(0, 2) == "69") {
                  //扫描得到69,码
                  this._go(LinkTypeCode.ProductList, { keyword: scanValue });
                  return;
                }
                await this.$emit("scan", scanValue);
              }
              window.api.setGlobalData({ key: 'scanValue', value: false });
            }
          }, 300);
        } catch (error) {
          this.$toast.fail('此功能只能在真机上使用！');
        }
      },

      onSearched() {
        this.$emit("input", this.keyword);
        this.$emit("search", this.keyword);
      }
    }
  };
</script>

<style lang="less">
  .search-bar-page {
    .van-overlay {
      background-color: #fff;
      position: absolute;
    }

    .search-bar {
      width: 100vw;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: #222222;

      .search-left {
        box-sizing: border-box;
        padding-left: 0.2rem;
        padding-right: 0.2rem;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
          &:nth-child(2) {
            margin-left: 0.2rem;
          }
        }
      }

      .search-centent {
        width: 100%;

        .search-text {
          padding-left: 0.2rem;
          height: 0.7rem;
          background: rgba(246, 246, 246, 1);
          border-radius: 0.08rem;
          color: rgba(182, 182, 182, 1);
          font-size: 0.24rem;
          font-weight: 400;
          text-align: left;
          display: flex;
          align-items: center;
          overflow: hidden;

          max-width: calc(100vw - 2.4rem);
          padding-right: 0.1rem;
          box-sizing: border-box;

          white-space: nowrap;
          text-overflow: ellipsis;

          img {
            width: 0.23rem;
            margin-right: 0.14rem;
          }

          span {
            max-width: calc(100% - 0.5rem);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      >.search-text {
        width: 1rem;
        font-size: 0.28rem;
        padding: 0 0.2rem;
      }
    }
  }
</style>